import { useOutletContext } from "react-router-dom";
import { AggregateScore, BlastRadius, Mquery } from "~/operations";
import { ReactNode } from "react";

export interface VariantOption {
  label: string;
  value: string;
  icon: ReactNode;
}

export interface PlatformCheckOutletContext {
  findingMrn: string;
  policyId?: string;
  check?: Mquery | null;
  checkScore?: AggregateScore;
  blastRadius?: BlastRadius | null;
  variants: VariantOption[];
  selectedVariant?: VariantOption;
  hasVariants: boolean;
  searchParams: URLSearchParams;
  setSearchParams: (params: URLSearchParams) => void;
}

export function usePlatformCheckOutletContext() {
  return useOutletContext<PlatformCheckOutletContext>();
}
